// extracted by mini-css-extract-plugin
export default {"container":"hY-z","list":"iY-z"};